export const NAVIGATION_STEP = 1;
